// extracted by mini-css-extract-plugin
module.exports = {"leftContent":"leftContent-qSo_a-D0","artical":"artical-2gdTPy_p"};